import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./taskpane.css";

/* global document, Office */

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  root?.render(<App title="SmartSuite" />);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(<NextApp title="SmartSuite" />);
  });
}
